<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <form role="form" @submit.stop.prevent="onSubmit">
      <!-----============================ OBS: No status deve ter um campo SELECT que irá trazer as opções criadas pelo usuário na parte cadastro de Status do Menu USUARIO  ==================------->

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Nome Conta</span>
          <vs-input
            size="large"
            class="w-full"
            name="Nome"
            placeholder="Minha Conta Débito"
            id="Nome"
            v-model="formCadastro.nomeConta"
            v-validate="{ required: true, min: 3 }"
            :state="validateState('Nome')"
            :class="validateClass('Nome')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Banco</span>
          <v-select
            :options="bancos"
            name="Banco"
            id="Banco"
            placeholder="Selecione o Banco :"
            v-model="formCadastro.idBanco"
            v-validate="{ required: true }"
            :state="validateState('Banco')"
            :class="validateClass('Banco')"
          ></v-select>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <span>Agência</span>
          <vs-input
            size="large"
            class="w-full"
            placeholder="0000"
            name="Agência"
            id="Agência"
            v-mask="'####'"
            v-model="formCadastro.agencia"
            v-validate="{ required: true, min: 3 }"
            :state="validateState('Agência')"
            :class="validateClass('Agência')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <span>Digito</span>
          <vs-input
            size="large"
            class="w-full"
            placeholder="0"
            v-mask="'#'"
            name="Digito Agência"
            id="Digito Agência"
            v-model="formCadastro.digitoAgencia"
            v-validate="{ required: true }"
            :state="validateState('Digito Agência')"
            :class="validateClass('Digito Agência')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <span>Conta</span>
          <vs-input
            size="large"
            class="w-full"
            placeholder="0"
            v-mask="'############'"
            name="Digito Conta"
            id="Digito Conta"
            v-model="formCadastro.conta"
            v-validate="{ required: true }"
            :state="validateState('Digito Conta')"
            :class="validateClass('Digito Conta')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <span>Digito</span>
          <vs-input
            size="large"
            class="w-full"
            placeholder="0"
            v-mask="'#'"
            name="Digito Conta"
            id="Digito Conta"
            v-model="formCadastro.digitoConta"
            v-validate="{ required: true }"
            :state="validateState('Digito Conta')"
            :class="validateClass('Digito Conta')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <vs-alert
        v-if="$validator.errors.all().length > 0"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        <ul>
          <li
            class="mb-2"
            v-for="error in $validator.errors.all()"
            :key="error.id"
          >
            {{ error }}
          </li>
        </ul>
      </vs-alert>
      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2"
            @click.stop.prevent="fecharModal()"
            >Cancelar</vs-button
          >
          <BotaoSubmit
            variant="success"
            :aguarde="aguardeCadastro"
          ></BotaoSubmit>
        </div>
      </div>
    </form>

    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import locale from './../../locale';
import * as lang from 'vuejs-datepicker/src/locale';
import vSelect from 'vue-select';
import service from '../../services';
import BotaoSubmit from '../../components/BotaoSubmit';
import jwt from 'jsonwebtoken';

export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
    dadosContaBancaria: {
      type: Object,
    },
  },
  watch: {
    dados() {
      this.preencheForm();
    },
    dadosContaBancaria() {
      this.preencheForm();
    },
  },
  data() {
    return {
      aguardeCadastro: false,
      idEmpresa: null,
      languages: lang,
      funcoesValicao: null,
      bancos: [],
      formCadastro: {
        idConta: null,
        idEmpresa: null,
        idBanco: null,
        status: true,
        nomeConta: '',
      },
      money: {
        decimal: '',
        thousands: '',
        prefix: '',
        suffix: '',
      },
    };
  },
  methods: {
    preencheForm() {
      if (this.dadosContaBancaria) {
        this.formCadastro.idConta = this.dadosContaBancaria.idContaBancaria;
        this.formCadastro.status =
          this.dadosContaBancaria.deletedAt == null ? true : false;
        this.formCadastro.nomeConta = this.dadosContaBancaria.nomeConta;
        this.formCadastro.agencia = this.dadosContaBancaria.agencia;
        this.formCadastro.digitoAgencia = this.dadosContaBancaria.digitoAgencia;
        this.formCadastro.conta = this.dadosContaBancaria.conta;
        this.formCadastro.digitoConta = this.dadosContaBancaria.digitoConta;
        this.formCadastro.idBanco = {
          id: this.dadosContaBancaria.idBanco,
          label: this.dadosContaBancaria.nomeBanco,
        };
      } else {
        this.resetForm();
      }
    },
    getDecoded() {
      const token = localStorage.getItem('user-token');
      if (token) {
        this.decoded = jwt.decode(token);
      }
      this.id_usuario = this.decoded.id_usuario;
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref) ? 'has-error' : '';
      }
      return null;
    },
    validateStyle(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return {
          border: '1px solid red !important',
          borderRadius: '5px',
        };
      }
      return null;
    },

    onSubmit() {
      this.formCadastro.idEmpresa = this.idEmpresa;
      this.formCadastro.idUsuario = this.decoded.id_usuario;

      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.dadosContaBancaria.editar == true) {
            this.aguardeCadastro = false;
            service
              .post(
                'usuarios-contas-bancarias',
                'editar-conta-bancaria',
                this.formCadastro,
              )
              .then(() => {
                this.aguardeCadastro = false;
                this.$vs.notify({
                  position: 'top-center',
                  title: 'Atenção',
                  text: `Conta Bancaria editada com sucesso`,
                  color: 'success',
                });
                this.$emit('close');
              })
              .catch((error) => {
                this.aguardeCadastro = true;
                this.$vs.notify({
                  position: 'top-center',
                  title: 'Atenção',
                  text: error,
                  color: 'danger',
                });
              });
          } else {
            this.aguardeCadastro = false;
            service
              .post(
                'usuarios-contas-bancarias',
                'adicionar-conta-bancaria',
                this.formCadastro,
              )
              .then(() => {
                this.aguardeCadastro = false;
                this.$vs.notify({
                  position: 'top-center',
                  title: 'Atenção',
                  text: `Operação Realizada com sucesso`,
                  color: 'success',
                });
                this.$emit('close');
              })
              .catch((error) => {
                this.aguardeCadastro = true;
                this.$vs.notify({
                  position: 'top-center',
                  title: 'Atenção',
                  text: error,
                  color: 'danger',
                });
              });
          }
        }
      });
    },
    fecharModal() {
      this.$emit('close');
      this.$emit('fecharModal');
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll('g', {}, `${model}/list/`).then((res) => {
        res.data.forEach((element) => {
          if (model == 'domBancos') {
            this[array].push({
              id: element[campoPK],
              label: element.COMPE + ' - ' + element[campoDescricao],
            });
          }
        });
      });
    },

    resetForm() {
      this.formCadastro = {
        idConta: null,
        idEmpresa: null,
        status: true,
        nomeConta: '',
      };
    },
    onReset() {
      this.$emit('cancel');
    },
  },
  mounted() {
    this.buscaDadosSelects('domBancos', 'bancos', 'shortName', 'idBanco');
    this.getDecoded();
    //this.buscaDadosSelects("domMunicipio", "cidades", "nomeCidade", "idCidade");
    this.$validator.localize('ptBr', locale);
  },
  components: {
    BotaoSubmit,
    'v-select': vSelect,
  },
};
</script>
<!------------ END SCRIPT ------------>
